export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const ERROR_LOGIN_SUCCESS = 'ERROR_LOGIN_SUCCESS';
export const GET_DETAIL_USER = 'GET_DETAIL_USER';
export const ERROR_GET_DETAIL_USER = 'ERROR_GET_DETAIL_USER';
export const LOGIN_GOOGLE = 'LOGIN_GOOGLE';
export const ERROR_LOGIN_GOOGLE = 'ERROR_LOGIN_GOOGLE';
export const LOGOUT = 'LOGOUT';
